/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import programs from "../programs.js";
import birdata from "../api.js";
import _ from "underscore";

function observePromise(p) {
  var o = ko.observable();
  p.then(o);
  return o;
}

const SurveyProgramViewModel = function(params) {
	var self = this;

  self.survey = params.parent.survey;

  self.programs = observePromise(Promise.all([programs(), params.parent.mePromise]).then(function([programs, me]) {
    return _.filter(programs, function(p) {
      return !p.canParticipate || p.canParticipate(me);
    });
  }));

  self.menuItems = ko.pureComputed(function() {
    var items = [];
    var groups = {};

    var programs = self.programs() || [];

    _.each(programs, function(program) {
      var group = program.group;
      if(group) {
        var programs = groups[group.code];
        if(!programs) {
          programs = [program];
          groups[group.code] = programs;
          items.push({
            type: 'group',
            name: group.name,
            group: group,
            programs: programs
          });
        } else {
          programs.push(program);
        }
      } else {
        items.push({
          type: 'program',
          name: program.name,
          program: program
        });
      }
    });

    return items;
  });

  self.selectedItem = ko.observable(null);

  self.menuItems.subscribe(function(items) {
    if(items && items.length && self.selectedItem() == null) {
      self.selectedItem(items[0]);
    }
  });

  self.selectItem = function() {
    self.selectedItem(this);
    if(this.type == 'program') {
      params.parent.selectProgram(this.program);
    } else if(this.type == 'group' && this.programs.length > 0) {
      params.parent.selectProgram(this.programs[0]);
    }
  }

  function selectItemForProgram(program) {
    if(program) {
      var item = _.find(self.menuItems(), function(m) {
        return m.program == program || _.contains(m.programs, program);
      });

      if(self.selectedItem() != item) {
        self.selectedItem(item);
      }
    }
  }

  ko.computed(function() {
    selectItemForProgram(self.survey.program());
  });

  // self.selectProgram = function(data, event) {
  //   // Take default action if user clicked a link
  //   if(event.target.tagName == 'A') {
  //       return true;
  //   }
  //   var program = this;

  //   params.parent.selectProgram(program);
  // };

  self.showNextTab = params.parent.showNextTab;
};

ko.components.register('survey-edit-program', {
	viewModel: SurveyProgramViewModel,
	template: require('../../templates/survey-edit-program.html')
});

export default SurveyProgramViewModel;
